import { ITestPlanInstrument } from "./TestplanInstrument";
import { IKeyedInProperty } from "./TestplanKeyedIn";
import { IPropertySpecification, PropertySpecification } from "../shared/PropertySpecification";
import { IGradeCalculatedData } from "../grade/GradeCalculatedData";
import { ICalculatedPropertyData } from "../shared/ICalculatedPropertyData";

export default interface ITestplanFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  codeId: string;
  instruments: ITestPlanInstrument[];
  keyedIns: IKeyedInProperty[];
  selectedInstruments: any[];
  selectedKeyedInProperties: any[];
  isPDC: boolean | string;
  properties?: IPropertySpecification[];
  allProperties?: IPropertySpecification[];
  sourceMappings?: IGradeCalculatedData[];
  selectedCalculatedProperty?: ICalculatedPropertyData[];
  calculatedProperties?: ICalculatedPropertyData[];
  sourceId?: any;
  allCalculatedDropdownList?: any;
  gradeCode?: string;
  gradeName?: string;
  gradeId?: string;
  showGrade?: boolean;
  showformula?: boolean;
  instrumentPartitions?: any[];
  selectedSource?: any[];
  selectedCalculatedProperties?: any;
  isSelectStripLength?: any;
  keyedInPartitions?: any[];
  isGradeCreatedWithTP?: number;
}

export class TestplanFormData implements ITestplanFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  codeId: string;
  instruments: ITestPlanInstrument[];
  keyedIns: IKeyedInProperty[];

  selectedInstruments: any[]
  selectedKeyedInProperties: any[]
  isPDC: boolean;
  properties?: IPropertySpecification[];
  allProperties?: IPropertySpecification[];
  sourceMappings?: IGradeCalculatedData[];
  selectedCalculatedProperty?: ICalculatedPropertyData[];
  calculatedProperties?: ICalculatedPropertyData[];
  sourceId?: any;
  allCalculatedDropdownList?: any;
  gradeCode?: string;
  gradeName?: string;
  gradeId?: string;
  showGrade?: boolean;
  showformula?: boolean;
  instrumentPartitions?: any[];
  selectedSource?: any[];
  selectedCalculatedProperties?: any;
  isSelectStripLength?: any;
  keyedInPartitions?: any[];
  isGradeCreatedWithTP?: number;
  constructor(
    isEditMode: boolean,
    requestId: string,
    id: string,
    name: string,
    descriptions: string,
    codeId: string,
    instruments: ITestPlanInstrument[],
    keyedIns: IKeyedInProperty[],
    isPDC: boolean,
    calculatedProperties?: ICalculatedPropertyData[], 
    sourceMappings?: IGradeCalculatedData[], 
    allProperties?: any,
    sourceId?: any,
    allCalculatedDropdownList?: any,
    gradeCode?: string,
    gradeName?: string,
    gradeId?: string,
    showGrade?: boolean,
    showformula?: boolean,
    instrumentPartitions?: any[],
    selectedSource?: any[],
    selectedCalculatedProperties?: any,
    isSelectStripLength?: any,
    keyedInPartitions?: any[],
    isGradeCreatedWithTP?: number
  ) {
    this.isEditMode = isEditMode;
    this.requestId = requestId;
    this.id = id;
    this.name = name;
    this.description = descriptions;
    this.codeId = codeId;
    this.instruments = instruments;
    this.keyedIns = keyedIns;
    this.selectedInstruments = [];
    this.selectedKeyedInProperties = [];
    this.isPDC = isPDC;
    this.properties = [];
    this.allProperties = allProperties || [];
    this.sourceMappings = sourceMappings;
    this.selectedCalculatedProperty = calculatedProperties;
    this.sourceId = sourceId;
    this.allCalculatedDropdownList = allCalculatedDropdownList;
    this.gradeCode = gradeCode;
    this.gradeName = gradeName;
    this.gradeId = gradeId;
    this.showGrade = showGrade;
    this.showformula = showformula;
    this.instrumentPartitions = instrumentPartitions;
    this.selectedSource = selectedSource;
    this.selectedCalculatedProperties = selectedCalculatedProperties;
    this.calculatedProperties = calculatedProperties;
    this.isSelectStripLength = isSelectStripLength;
    this.keyedInPartitions = keyedInPartitions;
    this.isGradeCreatedWithTP = isGradeCreatedWithTP;
    instruments.forEach(d => {
      this.selectedInstruments.push({
        label: d.name,
        value: d.id
      });
    });

    keyedIns.forEach(d => {
      this.selectedKeyedInProperties.push({
        label: d.name,
        value: d.id
      });
    });
  }
}

const defaultTestplanFormData = new TestplanFormData(false, "", "", "", "", "", [], [], false,[],[],[], "",[],"","","", false, false, [], [], [], "");
export { defaultTestplanFormData };
